<template>
  <!--  VISTA LISTAR-->
  <template v-if="view==='listar'">
    <HeaderComponent :title="title" :entity="entity" :clean-form="cleanLoadSelectedData"
                     @updateValues="setupUpdateValues"></HeaderComponent>
    <FilterRefactComponent :auth-token="authToken" :list-api="listApi" :table-columns="tableColumns" :queries="queries"
                           @updateValues="setupUpdateValues"></FilterRefactComponent>
    <TableComponent :entity="entity" :selected-data="selectedMacroEjecutor" :table-columns="tableColumns"
                    :collection-data="collectionData" :auth-token="authToken" :list-api="listApi"
                    :custom-update-selected-data="customUpdateSelectedData"
                    :custom-update-collection-data="customUpdateCollectionData" @updateValues="setupUpdateValues"
                    :updatePermission="'updates_concretas'"></TableComponent>
    <PaginateRefactComponent :auth-token="authToken" :list-api="listApi" :paginate="paginate"
                             :optionalParams="queries"
                             @updateValues="setupUpdateValues"></PaginateRefactComponent>
  </template>
  <!--    VISTA CREAR - ACTUALIZAR-->
  <template v-else>
    <CreateUpdateComponent :view="view" :paginate="paginate" :selected-data="selectedMacroEjecutor"
                           :load-data="loadDataMacroEjecutor" :entity="entity" :auth-token="authToken"
                           :list-api="listApi" :queries="queries"
                           @updateValues="setupUpdateValues">
      <component :is="childFormComponent" :load-data="loadDataMacroEjecutor"
                 :custom-update-value-data="customUpdateValueData" @updateValues="setupUpdateValues"></component>
    </CreateUpdateComponent>
  </template>
</template>
<script>
import {reactive, ref} from "vue";
import {useAuth} from "@/components/auth/store/composables";
import {copiaProfunda} from "@/common/constants";
import HeaderComponent from "@/layouts/main/HeaderComponent";
import TableComponent from "@/layouts/main/TableComponent";
import CreateUpdateComponent from "@/layouts/main/CreateUpdateComponent";
import FilterRefactComponent from "@/layouts/FilterRefactComponent";
import PaginateRefactComponent from "@/layouts/PaginateRefactComponent";
import MacroEjecutoresCrearActualizarComponent from "./components/MacroEjecutoresCrearActualizarComponent.vue"; 
import { useLayoutMain} from "@/layouts/main";

export default {
  name: 'MacroEjecutorCRUD',
  components: {
    HeaderComponent,
    FilterRefactComponent,
    TableComponent,
    PaginateRefactComponent,
    CreateUpdateComponent,
    MacroEjecutoresCrearActualizarComponent
  },
  data: function () {
    return {
      Object: Object,
      title: ' Macro Ejecutor',
      entity: {gender: 'm', value: 'macro ejecutor'},
      childFormComponent: 'MacroEjecutoresCrearActualizarComponent',
      tableColumns: {
        'id': {
          isFilter: false,
          isOrder: false,
          isVisibleInTable: true,
          value: 'ID'
        },
        'nombre': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: "Nombre",
        },
        'estado': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: false,
          value: 'Estado'
        },
        'created_at': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: false,
          value: 'Fecha de creación'
        }
      }
    }
  },
  async setup() {
    const authStored = useAuth();
    const view = ref('listar');
    const collectionData = ref([]);
    const authToken = ref(authStored.authToken);
    const selectedMacroEjecutor = ref({
      id: '',
      nombre: '',
      estado: ''
    });
    const loadDataMacroEjecutor = ref({
      nombre: '',
    });
    const listApi = reactive({
      create: process.env.VUE_APP_NEST_MACROEJECUTOR_CREATE,
      list: process.env.VUE_APP_NEST_MACROEJECUTOR_FINDALL,
      update: process.env.VUE_APP_NEST_MACROEJECUTOR_UPDATE,
      updateState: process.env.VUE_APP_NEST_MACROEJECUTOR_UPDATESTATE
    });
    const customUpdateValueData = (key, value) => {
      return value;
    };
    const customUpdateCollectionData = () => {
      return copiaProfunda(collectionData.value);
    };
    const {
      paginate,
      queries,
      setupUpdateValues,
      cleanLoadSelectedData
    } = await useLayoutMain(view, collectionData, authToken, selectedMacroEjecutor, loadDataMacroEjecutor, listApi);
    return {
      view,
      collectionData,
      authToken,
      selectedMacroEjecutor,
      loadDataMacroEjecutor,
      listApi,
      paginate,
      queries,
      setupUpdateValues,
      cleanLoadSelectedData,
      customUpdateCollectionData,
      customUpdateValueData,
    };
  }
}
</script>